import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { showToast } from '@nutui/nutui';
import request from '@/utils/request';
import { serverUri, markerData } from "./utils/constant";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination } from "swiper/modules";
import { lines } from './utils/lines';
import { gudaoLines } from './utils/gudao';
import { lineMenus, gdLineMenus, lineMarkers, emptyLineMarkers } from './utils/line';
import 'leaflet/dist/leaflet.css';
import L, { polyline } from 'leaflet';
import '@/utils/leaflet-rotate-src';
import '@/utils/leaflet.rotatedMarker';
import { createCustomIcon } from './utils/index';
import 'swiper/css';
let gMarker, gTMap, gMap, gLayer;
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    horizontalscreen: {
      created(el, binding, vnode) {
        function reset(init) {
          //在竖屏状态我们通过添加transform:rotate(90deg)，来让这个页面横过来
          el.style.webkitTransform = el.style = `transform: rotate(90deg) translate(0, -100%);transform-origin: 0 0;position: absolute;top: 0;left: 0;z-index: 999;`;
        }
        reset(true);
      }
    }
  },
  data() {
    return {
      TMap: undefined,
      map: undefined,
      marker: undefined,
      markerLayers: null,
      mapImageOverlay: null,
      smallImageOverlay: null,
      modules: [Autoplay, Pagination],
      serverUri,
      landscape: false,
      type: 2,
      sub_type: 0,
      scale: 13,
      latitude: 31.838601,
      longitude: 117.096639,
      visible: false,
      searchValue: '',
      customized: true,
      showRight: false,
      showBasic: false,
      showMarker: false,
      showPreview: false,
      markers: [],
      originMarkers: [],
      markerDetail: {},
      previewImgData: [],
      mapCtx: null,
      showWhere: false,
      dvisible: false,
      showNoMore: false,
      showList: false,
      firstLoadDone: false,
      showLineMenu: false,
      showGdLineMenu: false,
      lines,
      gudaoLines,
      lineMarkers,
      gdLineMenus,
      emptyLineMarkers,
      lineMarkerType: '',
      lineMarkerLayers: null,
      routeLine: null,
      polylineTimeOutId: null,
      lineMenu: [],
      staticV: 3.5
    };
  },
  beforeCreate() {},
  created() {
    this.closeDialog();
    this.configWxsdk();
    window.addEventListener('resize', () => {
      let width = document.documentElement.clientWidth,
        height = document.documentElement.clientHeight;
      if (width > height) {
        this.landscape = true;
        showToast.hide('show');
      } else {
        this.landscape = false;
      }
    }, false);

    // 播放背景音乐
    //this.dvisible = true

    this.$nextTick(() => {
      let el = document.getElementsByClassName('nut-dialog__footer-ok')[0];
      if (el) {
        el.onclick = () => {
          document.querySelector("audio").play();
        };
      }
      this.init();
    });
    window.addEventListener("load", event => {
      // this.configWxsdk()
    });
  },
  methods: {
    closeDialog() {
      showToast.loading('', {
        id: 'show',
        duration: 0 //0
      });
      this.$nextTick(() => {
        const loadEl = document.getElementsByClassName('nut-toast')[0];
        if (loadEl) {
          let width = document.documentElement.clientWidth,
            height = document.documentElement.clientHeight;
          if (width > height) {
            loadEl.setAttribute('style', `-webkit-transform: rotate(0);transform: rotate(0);width:100vw;height: 100vh;top: 0px;`);
          } else {
            loadEl.setAttribute('style', `-webkit-transform: rotate(90deg);transform: rotate(90deg);width:100vh;height: 100vw;transform-origin: calc(100vw / 2);top: 0px;`);
          }
        }
      });
    },
    init() {
      let lat = 29.905311;
      let lng = 118.197097;
      let c1 = L.latLng(29.161299, 116.506215);
      let c2 = L.latLng(30.675425, 119.706554);
      let bounds = L.latLngBounds(c1, c2);
      var map = L.map('box', {
        crs: L.CRS.EPSG3857,
        // 移除默认的旋转控件
        zoomSnap: 0,
        // 移除缩放和旋转功能
        inertia: false,
        zoomControl: false,
        center: [lat, lng],
        zoom: 8.5,
        maxZoom: 12.5,
        minZoom: 8.5,
        maxBounds: bounds,
        maxBoundsViscosity: 1.0,
        rotate: true,
        rotateControl: {
          closeOnZeroBearing: false
        },
        bearing: 90,
        touchRotate: false
      });
      this.map = map;
      var imageUrl = `${serverUri}/s_bg.jpg?v=${this.staticV}`;
      this.mapImageOverlay = L.imageOverlay(imageUrl, bounds).addTo(map);
      window.gMap = map;
      map.fitBounds(bounds);
      map.attributionControl.setPrefix('');
      // 禁止拖出边界
      map.on('drag', function () {
        map.panInsideBounds(bounds, {
          animate: false
        });
      });
      this.closeLoading();
      map.on('click', e => {
        if (this.showMarker) {
          this.showMarker = false;
        }
      });
      map.on('zoom', function () {
        console.log(map.getZoom());
      });
      map.on('click', function (e) {
        // e.latlng 包含点击位置的经纬度信息
        const latitude = e.latlng.lat.toFixed(6); // 纬度，保留6位小数
        const longitude = e.latlng.lng.toFixed(6); // 经度，保留6位小数

        // 在控制台输出坐标信息
        console.log(`点击位置坐标: 纬度, 经度 ${latitude} ${longitude}`);
        console.log("完整坐标对象:", e.latlng);
      });
    },
    addTips(tip_url) {
      function calculateSmallImageBounds(mainBounds) {
        const sw = mainBounds[0]; // 主图西南角（左下）[lat, lng]
        const ne = mainBounds[1]; // 主图东北角（右上）[lat, lng]

        // 计算主图的纬度和经度范围
        const latRange = ne[0] - sw[0]; // 纵向范围
        const lngRange = ne[1] - sw[1]; // 横向范围

        // 小图尺寸参数（占主图的比例）
        const smallImgScale = {
          width: 0.27,
          // 宽度为主体的20%
          height: 0.31 // 高度为主体的20%
        };

        // 计算小图的边界坐标（固定在右下角）
        const smallSw = [sw[0] + 0.1,
        // 小图底部与主图底部对齐
        ne[1] - lngRange * smallImgScale.width // 小图左侧 = 主图右侧 - 小图宽度
        ];
        const smallNe = [sw[0] + latRange * smallImgScale.height,
        // 小图顶部 = 主图底部 + 小图高度
        ne[1] - 0.1 // 小图右侧与主图右侧对齐
        ];
        return [smallSw, smallNe];
      }
      let mainImageBounds = [[29.161299, 116.506215], [30.675425, 119.706554]];

      // 7. 创建小图 imageOverlay
      const smallImageBounds = calculateSmallImageBounds(mainImageBounds);
      this.smallImageOverlay = L.imageOverlay(tip_url, smallImageBounds, {
        opacity: 1.0,
        // 小图不透明
        zIndex: 500 // 图层层级（高于主图）
      }).addTo(this.map);
    },
    changeType(type, cleanSearchV = false) {
      if (this.routeLine) {
        // this.routeLine.setLatLngs([]);
        this.map.removeLayer(this.routeLine);
      }
      this.showMarker = false;
      if (type == 3) {
        if (this.sub_type == 1) {
          this.sub_type = 0;
          return;
        }
        this.type = this.type == 3 ? '' : 3;
        this.dvisible = false;
        this.changeMapLayer(`${serverUri}/line_bg.jpg?v=${this.staticV}`);
        let lineMks = JSON.parse(JSON.stringify(this.emptyLineMarkers));
        let mks = lineMks.map(mk => {
          mk.icon_scale = mk.icon_scale - 5;
          return mk;
        });
        this.setLineMakers(mks, 'empty');
        return;
      } else if (type == 4) {
        this.changeMapLayer(`${serverUri}/gd_bg.jpg?v=${this.staticV}`);
      }
      if (this.lineMarkerLayers) {
        this.map.removeLayer(this.lineMarkerLayers);
        this.lineMarkerLayers = null;
      }
      showToast.loading('加载中...', {
        id: 'loadtype',
        duration: 2500,
        //0
        'custom-class': 'nut-toast-2'
      });
      this.$nextTick(() => {
        const loadEl = document.getElementsByClassName('nut-toast-2')[0];
        if (loadEl) {
          let width = document.documentElement.clientWidth,
            height = document.documentElement.clientHeight;
          if (width > height) {
            loadEl.setAttribute('style', `-webkit-transform: rotate(0);transform: rotate(0);width:100vw;height: 100vh;top: 0px;`);
          } else {
            loadEl.setAttribute('style', `-webkit-transform: rotate(90deg);transform: rotate(90deg);width:100vh;height: 100vw;transform-origin: calc(100vw / 2);top: 0px;left: -35vw;`);
          }
        }
      });
      this.type = type ? parseInt(type, 10) : '';
      let bgurl = type == 1 ? 'n_bg.jpg' : 's_bg.jpg';
      if (type != 4) {
        this.changeMapLayer(`${serverUri}/${bgurl}?v=${this.staticV}`);
      }
      if (cleanSearchV) {
        this.searchValue = '';
      }
      this.getMarkers();
      this.map.setZoom(8.5);
      this.dvisible = false;
    },
    getMarkers() {
      const {
        type,
        staticV
      } = this;
      const markers = markerData.filter(item => {
        return parseInt(type, 10) === parseInt(item.type, 10); //item.name.indexOf('松') !== -1 //parseInt(type, 10) === parseInt(item.type, 10)
      }).map(item => {
        item.iconPath = `${serverUri}/${item.icon}?v=${staticV}`;
        item.zIndex = 1;
        return item;
      });
      this.originMarkers = markers;
      this.markers = markers;
      const {
        searchValue
      } = this;
      if (searchValue.length >= 1) {
        this.searchMarkers(searchValue);
      } else {
        this.setMakers(this.markers);
      }
    },
    getMarker(id) {
      const data = this.originMarkers.find(item => {
        return parseInt(id, 10) === parseInt(item.id, 10);
      });
      data.imgData = data.thumbs.map(img => {
        return {
          src: `${serverUri}/${img}`
        };
      });
      this.markerDetail = data;

      // 设置地图的新中心
      // var newCenter = [data.icon_latitude, data.icon_longitude];
      // this.map.setView(newCenter, 11);

      this.showRight = false;
      this.showMarker = true;
    },
    searchMarkers(v) {
      const {
        originMarkers
      } = this;
      this.markers = originMarkers.filter(item => {
        return item.name.indexOf(v) !== -1;
      });
      if (this.markers.length >= 1) {
        this.setMakers(this.markers);
      }
      this.showBasic = this.markers.length < 1;
    },
    setMakers(markers, anchor = undefined) {
      if (this.markerLayers) {
        this.map.removeLayer(this.markerLayers);
        this.markerLayers = null;
      }
      let layers = markers.map(marker => {
        let scale = 80 * (marker.icon_scale / 100);
        let width = parseInt(scale * marker.wh, 10);
        let height = parseInt(scale, 10);
        let iconOpts = {
          iconUrl: marker.iconPath,
          iconSize: [width, height]
        };
        if (anchor !== undefined) {
          iconOpts.iconAnchor = [width / anchor, height / anchor];
        }
        let icon = L.icon(iconOpts);
        let mk = L.marker([marker.icon_latitude, marker.icon_longitude], {
          icon: icon
        }).on('click', () => {
          if (marker.hasOwnProperty('s_id') && marker.name !== '') {
            marker.imgData = marker.thumbs.map(img => {
              return {
                src: `${serverUri}/${img}`
              };
            });
            this.markerDetail = marker;
            this.showMarker = true;
          } else if (marker.hasOwnProperty('id')) {
            this.getMarker(marker.id);
          }
        });
        mk.setRotationAngle(90);
        return mk;
      });
      let markerLayers = L.layerGroup(layers);
      this.markerLayers = markerLayers;
      this.map.addLayer(markerLayers);
    },
    changeWhere() {
      if (this.showMarker) {
        this.showMarker = false;
        return false;
      }
      this.showWhere = !this.showWhere;
    },
    callPhone(tel) {
      window.location.href = `tel:${tel}`;
    },
    configWxsdk() {
      request({
        url: '/api/wx_hswl_config',
        method: 'post',
        params: {}
      }).then(res => {
        const {
          data
        } = res;
        wx.config({
          debug: false,
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId,
          // 必填，公众号的唯一标识
          timestamp: data.timestamp,
          // 必填，生成签名的时间戳
          nonceStr: data.nonceStr,
          // 必填，生成签名的随机串
          signature: data.signature,
          // 必填，签名
          jsApiList: ['openLocation', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: '黄山市古树观鸟导览图',
            // 分享标题
            desc: '黄山市古树观鸟导览图',
            // 分享描述
            link: 'https://gsgn.linkingtrip.cn',
            // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: ``,
            // 分享图标
            success: function () {
              // 设置成功
            }
          });
          wx.updateTimelineShareData({
            title: '黄山市古树观鸟导览图',
            // 分享标题
            link: 'https://gsgn.linkingtrip.cn',
            // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: ``,
            // 分享图标
            success: function () {
              // 设置成功
            }
          });
        });
      });
    },
    openAd(marker) {
      wx.openLocation({
        latitude: parseFloat(marker.latitude),
        // 纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(marker.longitude),
        // 经度，浮点数，范围为180 ~ -180。
        name: marker.name,
        // 位置名
        address: marker.hasOwnProperty('address') ? marker.address : marker.name,
        // 地址详情说明
        scale: 1,
        // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    },
    closeLoading() {
      setTimeout(() => {
        if (!this.firstLoadDone) {
          this.dvisible = true;
        }
        this.firstLoadDone = true;
        const targetElement = document.querySelector('.leaflet-control-container > .leaflet-bottom:last-child');
        if (targetElement) {
          targetElement.setAttribute('class', 'leaflet-copyright');
        }
        setTimeout(() => {
          showToast.hide('show');
        }, 1000);
      }, 10);
    },
    showTable() {
      this.showList = true;
    },
    openLineMenu(index) {
      this.lineMenu = lineMenus[index];
      this.showLineMenu = true;
    },
    openGdLineMenu() {
      this.lineMenu = this.gdLineMenus;
      this.showGdLineMenu = true;
      console.log('ppp');
    },
    changeMapLayer(newSrc) {
      this.map.setZoom(6);
      if (this.markerLayers) {
        this.map.removeLayer(this.markerLayers);
        this.markerLayers = null;
      }
      if (this.smallImageOverlay) {
        this.map.removeLayer(this.smallImageOverlay);
        this.smallImageOverlay = null;
      }

      // 直接获取ImageOverlay内部的img元素并修改其src属性
      const {
        mapImageOverlay
      } = this;
      if (mapImageOverlay && mapImageOverlay._image) {
        // 添加淡入淡出效果
        mapImageOverlay._image.style.transition = 'opacity 3s ease';
        mapImageOverlay._image.style.opacity = 0;

        // 设置新的图片源
        mapImageOverlay._image.src = newSrc;
        // 图片加载完成后显示
        mapImageOverlay._image.onload = function () {
          mapImageOverlay._image.style.opacity = 0.8;
        };
      }
    },
    polyline(name) {
      if (this.routeLine) this.map.removeLayer(this.routeLine);
      if (this.polylineTimeOutId) clearTimeout(this.polylineTimeOutId);
      this.showMarker = false;
      this.setLineMakers(this.lineMarkers, 'line');
      let line = [];
      if (this.showLineMenu) {
        line = lines.find(line => {
          return line['name'] === name;
        });
        this.showLineMenu = false;
      } else if (this.showGdLineMenu) {
        line = gudaoLines.find(line => {
          return line['name'] === name;
        });
        this.showGdLineMenu = false;
      }
      let staticV = this.staticV;
      let points = line.points.map(point => {
        point.iconPath = `${serverUri}/${point.icon}?v=${staticV}`;
        return point;
      });
      this.map.setView(line.center, line.zoom);
      this.setMakers(points, 2);

      // 存储所有点的经纬度数组，用于创建线路
      const latlngs = line.points.map(point => [point.icon_latitude, point.icon_longitude]);
      const {
        map
      } = this;

      // 创建线路（初始不可见）
      let routeLine = L.polyline([], {
        color: '#548b57',
        weight: 4,
        opacity: 1,
        lineCap: 'round',
        lineJoin: 'round'
      }).addTo(this.map);
      this.routeLine = routeLine;

      // 动画相关变量
      let animationFrame;
      let animationProgress = 0; // 0-1之间的进度值
      const animationDuration = 3000; // 动画总时长（毫秒）
      let startTime;

      // 计算两点之间的距离比例
      function getPointAlongLine(latlngs, progress) {
        // 计算总距离
        let totalDistance = 0;
        const segmentDistances = [];

        // 计算每个线段的距离
        for (let i = 0; i < latlngs.length - 1; i++) {
          const distance = map.distance(latlngs[i], latlngs[i + 1]);
          segmentDistances.push(distance);
          totalDistance += distance;
        }

        // 计算当前进度对应的距离
        const targetDistance = totalDistance * progress;

        // 找到当前进度所在的线段
        let accumulatedDistance = 0;
        let segmentIndex = 0;
        for (; segmentIndex < segmentDistances.length; segmentIndex++) {
          if (accumulatedDistance + segmentDistances[segmentIndex] >= targetDistance) {
            break;
          }
          accumulatedDistance += segmentDistances[segmentIndex];
        }

        // 计算在线段中的相对进度
        const remainingDistance = targetDistance - accumulatedDistance;
        const segmentProgress = remainingDistance / segmentDistances[segmentIndex];

        // 计算线段上的点
        const startPoint = latlngs[segmentIndex];
        const endPoint = latlngs[segmentIndex + 1];

        // 计算中间点坐标
        const lat = startPoint[0] + (endPoint[0] - startPoint[0]) * segmentProgress;
        const lng = startPoint[1] + (endPoint[1] - startPoint[1]) * segmentProgress;

        // 返回从起点到当前点的所有坐标
        return [...latlngs.slice(0, segmentIndex + 1), [lat, lng]];
      }

      // 动画函数
      function animateRoute(timestamp) {
        if (!startTime) startTime = timestamp;

        // 计算进度（0-1）
        const elapsed = timestamp - startTime;
        animationProgress = Math.min(elapsed / animationDuration, 1);

        // 更新线路显示
        const currentPoints = getPointAlongLine(latlngs, animationProgress);
        routeLine.setLatLngs(currentPoints);

        // 如果动画未完成，继续请求下一帧
        if (animationProgress < 1) {
          animationFrame = requestAnimationFrame(animateRoute);
        }
      }
      animationProgress = 0;
      startTime = null;
      routeLine.setLatLngs([]);

      // 开始动画
      animationFrame = requestAnimationFrame(animateRoute);
      // 设置点位固定在视窗内
      // this.map.fitBounds(L.latLngBounds(latlngs), { padding: [50, 50] });

      this.polylineTimeOutId = setTimeout(() => {
        if (routeLine) {
          routeLine.setLatLngs([]);
        }
      }, 30000);
    },
    setLineMakers(markers, lineMarkerType, anchor = undefined) {
      if (this.lineMarkerLayers && this.lineMarkerType == lineMarkerType) {
        return;
      }
      this.lineMarkerType = lineMarkerType;
      if (this.lineMarkerLayers) {
        this.map.removeLayer(this.lineMarkerLayers);
        this.lineMarkerLayers = null;
      }
      let layers = markers.map(marker => {
        let scale = 46 * (marker.icon_scale / 100);
        let width = parseInt(scale * marker.wh, 10);
        let height = parseInt(scale, 10);
        let iconOpts = {
          iconUrl: `${serverUri}/${marker.icon}?v=${this.staticV}`,
          iconSize: [width, height]
        };
        if (anchor !== undefined) {
          iconOpts.iconAnchor = [width / anchor, height / anchor];
        }
        let icon = L.icon(iconOpts);
        let mk = L.marker([marker.icon_latitude, marker.icon_longitude], {
          icon: icon
        }).on('click', () => {
          marker.imgData = marker.thumbs.map(img => {
            return {
              src: `${serverUri}/${img}`
            };
          });
          this.markerDetail = marker;
          this.showMarker = true;
          // if (marker.hasOwnProperty('id')) {
          //   this.getMarker(marker.id)
          // }
        });
        mk.setRotationAngle(90);
        return mk;
      });
      let lineMarkerLayers = L.layerGroup(layers);
      this.lineMarkerLayers = lineMarkerLayers;
      this.map.addLayer(lineMarkerLayers);
    },
    px2vw(px) {
      let v = px / 750 * 100;
      return `${v}vw`;
    },
    px2vh(px) {
      let v = px / 1334 * 100;
      return `${v}vh`;
    },
    px2rem($px) {
      let v = $px / 30 * 1;
      return `${v}rem`;
    }
  }
};